import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import React from "react";
import styled from "styled-components";
import { fireAuth } from "../firebase";
import { FcGoogle } from "react-icons/fc";
import { CommonButtonStyled } from "./common-styled";

const GoogleLoginButton = () => {
  return (
    <Button
      onClick={async () => {
        const provider = new GoogleAuthProvider(); // provider를 구글로 설정
        const data = await signInWithPopup(fireAuth, provider);

        console.log(data);
      }}
    >
      <FcGoogle />
      구글 로그인
    </Button>
  );
};

export default GoogleLoginButton;

const Button = styled(CommonButtonStyled)`
  font-family: Roboto;

  gap: 6px;

  background-color: #fff;
`;
